<template>
  <div class="tabs-container">
    <ul class="tab" :class="{ 'tab-block': this.block }">
      <li class="tab-item" :key="i" v-for="(tab, i) in tabs" :class="{ active: tab.isActive }">
        <a href="#" @click.prevent="selectTab(tab.hash)">
          {{ tab.name }}
          <span
            class="tab-badge"
            :class="tab.badgeType ? `tab-badge-${tab.badgeType}` : null"
            v-if="tab.badge"
          >{{ tab.badge }}</span>
        </a>

        <div class="tab-hint" v-if="tab.hint">
          <div class="tab-hint-title">
            <fa-icon :icon="['fal', 'sparkles']" />
            <strong>Novidade</strong>
          </div>
          <p>{{ tab.hint }}</p>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="$emit('hint-dismissed', tab.hash)"
          >Entendi</button>
        </div>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabs: [],
      activeTabHash: '',
    };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    if (this.tabs.length) {
      this.selectTab(this.tabs[0].hash);
    }
  },
  methods: {
    findTab(hash) {
      return this.tabs.find(tab => tab.hash === hash);
    },
    selectTab(selectedTabHash) {
      const selectedTab = this.findTab(selectedTabHash);
      if (!selectedTab) {
        return;
      }

      this.tabs.forEach((tab) => {
        // eslint-disable-next-line no-param-reassign
        tab.isActive = tab.hash === selectedTab.hash;
      });

      this.$emit('changed', { tab: selectedTab });
      this.activeTabHash = selectedTab.hash;
    },
    activeTab() {
      return this.activeTabHash;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.tab {
  .tab-item {
    a:focus {
      box-shadow: none;
    }
  }

  .tab-badge {
    background: lighten($primary-color, 36%);
    border-radius: 1rem;
    color: $primary-color;
    font-size: $font-size-xs;
    font-weight: 700;
    letter-spacing: .03rem;
    margin-left: $unit-1;
    padding: 0 $unit-2;
    text-transform: uppercase;
    vertical-align: middle;
  }

  .tab-item {
    position: relative;
  }

  .tab-hint {
    background: $dark-color;
    border-radius: $border-radius;
    box-shadow: 0 .2rem .6rem rgba(0, 0, 0, .25);
    color: $light-color;
    left: 50%;
    margin-top: $unit-2;
    padding: $layout-spacing;
    position: absolute;
    text-transform: none;
    top: 100%;
    transform: translateX(-50%);
    width: 13rem;
    z-index: 200;

    &::before {
      border: .25rem solid transparent;
      border-bottom-color: $dark-color;
      content: "";
      left: 50%;
      margin-left: -.25rem;
      position: absolute;
      top: -.5rem;
    }

    .tab-hint-title {
      align-items: center;
      color: lighten($primary-color, 25%);
      display: flex;
      gap: $unit-1;
      margin-bottom: $unit-1;
    }

    p {
      font-size: $font-size-sm;
      line-height: 1.4;
      margin: 0 0 $layout-spacing;
    }
  }

  .tab-badge-alert {
    animation: tab-badge-pulse 1.6s infinite;
    background: lighten($error-color, 42%);
    color: $error-color;
  }
}

@keyframes tab-badge-pulse {
  0% { opacity: 1; }
  50% { opacity: .45; }
  100% { opacity: 1; }
}
</style>
